// Define column configuration dynamically
export const columns = [
  {
    field: "transactionDate",
    header: "Transaction Date",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "transactionDate")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.transactionDate || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "vendorName",
    header: "Vendor Name",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "vendorName")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.vendorName || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "transactionType",
    header: "Transaction Type",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "transactionType")}
        className={`p-2 ${
          row?.transactionType === "Issued"
            ? "bg-red100"
            : row?.transactionType === "Receipt"
            ? "bg-gren100"
            : "bg-gray100"
        } rounded-md cursor-pointer flex items-center`}
      >
        <span
          className={`inline-block w-2.5 h-2.5 mr-2 rounded-full ${
            row?.transactionType === "Issued"
              ? "bg-red500"
              : row?.transactionType === "Receipt"
              ? "bg-green500"
              : "bg-gray500"
          }`}
        ></span>
        <p className="text-sm font-medium text-gray700">
          {row?.transactionType === "Issued" ? "Issued" : "Receipt"}
        </p>
      </div>
    ),
  },
  {
    field: "itemCodeDetails",
    header: "Item name",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "name")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.itemCodeDetails?.name || "--"}
        </p>
      </div>
    ),
  },
 
  {
    field: "quantity",
    header: "Quantity",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "quantity")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.quantity || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "unitDetails",
    header: "Unit",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "unit")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.unitDetails?.[0]?.unit || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "cost",
    header: "Cost",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "cost")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.cost || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "total",
    header: "Total Cost",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "total")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.total || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "balanceQuantity",
    header: "Balance Quantity",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "balanceQuantity")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-gray700">
          {row?.balanceQuantity || "--"}
        </p>
      </div>
    ),
  },
  {
    field: "itemCodeDetails",
    header: "Item details",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "itemDescription")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-green700">View</p>
      </div>
    ),
  },
];

// Search filter options configuration
export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  {
    filterType: "Filter",
    inputName: "transactionType",
    options: [
      {
        name: "Issued",
        code: "Issued",
      },
      {
        name: "Receipt",
        code: "Receipt",
      },
    ],
  },
];

// Search filter component
export const SearchFilter = ({ sortType, setSortType }) => {
  return (
    <div className="flex items-center space-x-4 p-4 bg-white shadow-sm rounded-md">
      <label className="text-gray700 font-semibold">Sort By:</label>
      <select
        className="border rounded p-2 text-sm focus:ring focus:ring-indigo-300"
        value={sortType}
        onChange={(e) => setSortType(e.target.value)}
      >
        {searchBy.options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};
